module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also By Margery Allingham")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Blackkerchief Dick")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The White Cottage Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Crime at Black Dudley")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Mystery Mile")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Look to the Lady")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Police at the Funeral")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Sweet Danger")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death of a Ghost")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Flowers for the Judge")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Case of the Late Pig")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Dancers in Mourning")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Fashion in Shrouds")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Black Plumes")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Traitor’s Purse")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Dance of the Years")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Coroner’s Pidgin")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("More Work for the Undertaker")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Tiger in the Smoke")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Beckoning Lady")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Hide My Eyes")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The China Governess")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Mind Readers")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Cargo of Eagles")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Darings of the Red Rose")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section-title subhead"
  }, [_vm._v("Novellas & Short Stories")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Mr. Campion: Criminologist")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Mr. Campion and Others")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Wanted: Someone Innocent")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Casebook of Mr Campion")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Deadly Duo")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("No Love Lost")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Allingham Casebook")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Allingham Minibus")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Return of Mr. Campion")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Room to Let: A Radio-Play")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Campion at Christmas")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section-title subhead"
  }, [_vm._v("Non-Fiction")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Oaken Heart: The Story of an English Village at War")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section-title subhead"
  }, [_vm._v("As Maxwell March")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Rogue’s Holiday")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Man of Dangerous Secrets")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Devil and Her Son")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d72e5b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alsobymargeryallingham.vue
// module id = 66
// module chunks = 0